<div class="loading"><i class="uil uil-spinner-alt"></i></div>